
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.785 11.0135L14.6184 2.84685C14.4465 2.69953 14.2264 2.62063 14 2.62519H10.5C7.43946 2.62519 4.95837 5.10628 4.95837 8.16685V19.8335C4.95837 22.8941 7.43946 25.3752 10.5 25.3752H17.5C20.5606 25.3752 23.0417 22.8941 23.0417 19.8335V11.6669C23.0457 11.4237 22.9534 11.1889 22.785 11.0135ZM14.875 5.58852L20.0784 10.7919H16.3334C15.528 10.7919 14.875 10.1389 14.875 9.33352V5.58852ZM6.70837 19.8335C6.71478 21.9249 8.40862 23.6188 10.5 23.6252H17.5C19.5915 23.6188 21.2853 21.9249 21.2917 19.8335V12.5419H16.3334C14.5615 12.5419 13.125 11.1054 13.125 9.33352V4.37519H10.5C8.40862 4.38159 6.71478 6.07543 6.70837 8.16685V19.8335Z","fill":"currentColor"}})])
          )
        }
      }
    